/** Shared Recharts theming pulled from the design tokens (one place). */
import type { CSSProperties } from "react";

export const tooltipContentStyle: CSSProperties = {
  background: "rgb(var(--color-bg-elevated))",
  border: "1px solid rgb(var(--color-border))",
  borderRadius: 8,
  color: "rgb(var(--color-fg))",
};
